import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";

import SplashScreen from "./pages/SplashScreen";
import Home from "./pages/Home";
import ServiceExplorer from "./pages/ServiceExplorer";
import Profile from "./pages/Profile";

// NEW: relocation flow pages
import ProfileSetup1 from "./pages/ProfileSetup1";
import ProfileSetup2 from "./pages/ProfileSetup2";
import ProfileSetup3 from "./pages/ProfileSetup3";
import RelocationResults from "./pages/RelocationResults";

// Details + Explore pages
import AreaDetails from "./pages/AreaDetails";
import ExploreMore from "./pages/ExploreMore";
import CompareAreas from "./pages/CompareAreas";

// AI-powered neighborhood search
import AIChat from "./pages/AIChat";

// Anonymous neighborhood review submission (Week 2 RAG build, 2026-04-25)
import SubmitReview from "./pages/SubmitReview";

// Site-level feedback (NPS + Sean Ellis PMF) — Sunday polish 2026-05-03.
// Different from /submit-review (which is for neighborhood reviews).
import SiteFeedback from "./pages/SiteFeedback";

// Admin-only feedback dashboard — gated by SITE_FEEDBACK_ADMIN_TOKEN.
// Sunday polish 2026-05-03 (round 2).
import FeedbackDashboard from "./pages/FeedbackDashboard";

// Sunday polish session 2026-05-03: removed login layer entirely.
// /signup, /signin, /create-account, /select-persona routes were removed.
// User flow now: SplashScreen (/) → "Try LocalGenie" CTA → /home (AIChat).
// Anonymous use only — sessionId managed by Redis on the backend.
// If we ever want accounts back, restore from git history before this commit.

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SplashScreen />} />

        {/* Main app — AIChat (multi-agent UI). /home is the canonical entry.
            /chat/:sessionId kept for backwards-compat with any saved chat URLs.
            /home-old preserves the original V1 Home.jsx as a fallback during
            polish iteration. */}
        <Route path="/home" element={<AIChat />} />
        <Route path="/chat/:sessionId" element={<AIChat />} />
        <Route path="/home-old" element={<Home />} />

        <Route path="/services" element={<ServiceExplorer />} />

        {/* Profile setup wizard — kept but currently unreached from main flow.
            Deferred decision (LG, 2026-05-03) on whether to wire up or remove. */}
        <Route path="/profile-setup-1" element={<ProfileSetup1 />} />
        <Route path="/profile-setup-2" element={<ProfileSetup2 />} />
        <Route path="/profile-setup-3" element={<ProfileSetup3 />} />
        <Route path="/relocation-results" element={<RelocationResults />} />
        <Route path="/profile" element={<Profile />} />

        {/* Explore → Detail page */}
        <Route path="/areas/:slug" element={<AreaDetails />} />
        {/* Detail → Explore More page */}
        <Route path="/areas/:slug/explore" element={<ExploreMore />} />
        {/* Detail → Compare Areas page */}
        <Route path="/areas/:slug/compare" element={<CompareAreas />} />

        {/* AI-Powered Neighborhood Search (alias for /home) */}
        <Route path="/ai" element={<AIChat />} />

        {/* Anonymous review submission — Week 2 RAG build (2026-04-25) */}
        <Route path="/submit-review" element={<SubmitReview />} />

        {/* Site-level feedback (NPS + Sean Ellis PMF) — Sunday polish 2026-05-03.
            Linked from SplashScreen footer. Captures product reaction during launch. */}
        <Route path="/feedback" element={<SiteFeedback />} />

        {/* Admin-only feedback dashboard. Token-gated client-side; the API is
            also token-gated server-side, so an unauthenticated /admin/feedback
            visitor can see the page chrome but no data. Sunday polish 2026-05-03. */}
        <Route path="/admin/feedback" element={<FeedbackDashboard />} />
      </Routes>

      {/* Vercel Analytics — added 2026-05-03 (Sunday polish session).
          Tracks page views, visitors, top pages. Free Hobby tier.
          Companion to Cloudflare Web Analytics beacon in public/index.html. */}
      <Analytics />
    </Router>
  );
}

export default App;
